<template>
  <div class="row justify-content-center personalLoan-steps">
   <step-back-button v-if="canGoPrevious" @click="this.onPrevious"/>
   <transition v-bind:name="transitionName" mode='out-in'>
    <component :is='currentStepComponent' class="form-container" :current-user="currentUser" @on-submit="this.updateUser" @loading-toggle="handleLoadingToggle"></component>
   </transition>
  </div>
</template>

<style lang="scss" scoped>
  .form-container {
    display: inline-block;
    width: 100%;
    text-align: center;
  }
</style>

<script>
import ApiClient from '../utils/api-client'
import StepBackButton from '@/components/StepBackButton'
import * as mutationTypes from '@/store/mutation-types.js'

// COMPONENTS STEPS
import FullNameStep from '@/components/AdditionalInformationPersonalLoan/FullNameStep'
import ContactsStep from '@/components/AdditionalInformationPersonalLoan/ContactsStep.vue'
import OccupationKindStep from '@/components/AdditionalInformationPersonalLoan/OccupationKindStep.vue'
import BaseSalaryStep from '@/components/AdditionalInformationPersonalLoan/BaseSalaryStep.vue'
import AdditionalIncomeStep from '@/components/AdditionalInformationPersonalLoan/AdditionalIncomeStep.vue'
import MaritalStatusStep from '@/components/AdditionalInformationPersonalLoan/MaritalStatusStep.vue'
import NationalityStep from '@/components/AdditionalInformationPersonalLoan/NationalityStep.vue'
import GenreStep from '@/components/AdditionalInformationPersonalLoan/GenreStep.vue'
import CityStep from '@/components/AdditionalInformationPersonalLoan/CityStep.vue'
import ScholarityStep from '@/components/AdditionalInformationPersonalLoan/ScholarityStep.vue'
import AddressStep from '@/components/AdditionalInformationPersonalLoan/AddressStep.vue'
import AddressConfirmationStep from '@/components/AdditionalInformationPersonalLoan/AddressConfirmationStep.vue'
import IdentificationDocumentStep from '@/components/AdditionalInformationPersonalLoan/IdentificationDocumentStep.vue'
import IdentificationPhotoStep from '@/components/AdditionalInformationPersonalLoan/IdentificationPhotoStep.vue'
import AddressDocumentStep from '@/components/AdditionalInformationPersonalLoan/AddressDocumentStep'
import PaymentDocumentStep from '@/components/AdditionalInformationPersonalLoan/PaymentDocumentStep'
import BankDocumentStep from '@/components/AdditionalInformationPersonalLoan/BankDocumentStep'
import FinishedStep from '@/components/AdditionalInformationPersonalLoan/FinishedStep'

let components = Object.assign({
    'step-back-button': StepBackButton,
    'full-name-step': FullNameStep,
    'contacts-step': ContactsStep,
    'occupation-kind-step': OccupationKindStep,
    'base-salary-step': BaseSalaryStep,
    'additional-income-step': AdditionalIncomeStep,
    'marital-status-step': MaritalStatusStep,
    'nationality-step': NationalityStep,
    'genre-step': GenreStep,  
    'city-step': CityStep,
		'scholarity-step': ScholarityStep,
		'address-step': AddressStep,
		'address-confirmation-step': AddressConfirmationStep,
    'identification-document-step': IdentificationDocumentStep,
    'identification-photo-step': IdentificationPhotoStep,
    'address-document-step': AddressDocumentStep,
    'payment-document-step': PaymentDocumentStep,
    'bank-document-step': BankDocumentStep,
    'finished-step': FinishedStep
})

export default {
  /* eslint-disable */
  data() {
    return {
      transitionName: 'slide-left',
      solicitacaoId: this.$route.params.id,
      currentUser: null,
    }
  },
  components: components,
  computed: {
    currentStepComponent: function() {
      if(this.currentUser !== null) {

        if(!this.currentUser.Status || this.currentUser.Status === "" || this.currentUser.Status == "LIZA") {
          this.currentUser.Status = "full-name";
        }

        return this.currentUser.Status + "-step";

      } else {
        return this.currentUser;
      }
    },
    progress: function() {
      const stepsAmount = Object.keys(components).length
      const currentStepNumber = Object.keys(components).indexOf(this.currentStepComponent) + 1
      return Math.round( (currentStepNumber * 100) / stepsAmount )
    },
    canGoPrevious: function() {
      if(!this.currentUser) { 
        return false
      }

      const stepsThatCantGoBack = ['full-name', 'finished', 'cancelado']
      return !stepsThatCantGoBack.includes(this.currentUser.Status)
    }
  },
  methods: {
    updateUser: function(newData) {
      newData = Object.assign(newData, {StepType: 'next'})
      this.transitionName = 'slide-left'

     //ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/personal-loan-informations`, {data: newData})
     ApiClient.put(`solicitacoes/${this.solicitacaoId}/personal-loan-informations`, {data: newData})
        .then(response => {
          console.log("updateUser",response)
          this.currentUser = response.data
        }).catch(()=>{this.$store.commit(mutationTypes.STOP_LOADING);})
    },
    onPrevious: function() {
      this.transitionName = 'slide-right'
      
      this.$store.commit(mutationTypes.START_LOADING)
      // ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/personal-loan-informations`, {data: {StepType: 'previous'}})
      ApiClient.put(`solicitacoes/${this.solicitacaoId}/personal-loan-informations`, {data: {StepType: 'previous'}})
        .then(response => {
          console.log("onPrevious",response)
          this.currentUser = response.data
          this.$store.commit(mutationTypes.STOP_LOADING);
        }).catch(()=>{this.$store.commit(mutationTypes.STOP_LOADING);})
        
    },
    handleLoadingToggle(isLoading) {
      if(isLoading) {
        this.$store.commit(mutationTypes.START_LOADING)
      } else {
        this.$store.commit(mutationTypes.STOP_LOADING)
      }
    }
  },
  created() {

    const solicitacaoId = this.$route.params.id

    this.$store.commit(mutationTypes.START_LOADING)
    // ApiClient.get_GO(`solicitacoes/${solicitacaoId}`)
    ApiClient.get(`solicitacoes/${solicitacaoId}`)
      .then(response => {
        this.currentUser = response.data
        this.$store.commit(mutationTypes.STOP_LOADING);
      })
      .catch(error => {
        window.error = error
        if(error.response && error.response.status == 404) {
          this.$router.push('/not-found')
        }

        if(error.response && error.response.status == 401) {
         window.location.href="#/";
        }
        this.$store.commit(mutationTypes.STOP_LOADING);
      })
  },
  beforeUpdate() {
    this.$Loading.update(this.progress);
  }
}
</script>



// WEBPACK FOOTER //
// src/views/AdditionalInformationPersonalLoan.vue